// frontend/shared/src/fees.ts —— 对客费用文案的公共拼装（H5 选卡 / 费率说明页、官网产品卡共用，DRY）
// 0040（2026-10-16 用户拍板）：授权撤销费 = |撤销金额| × auth_cancel_fee_rate% +（|撤销金额| ≥ auth_cancel_fee_min 时）auth_cancel_fee_fixed。
// 费用从 USDT 余额扣，一律写 USDT；门槛是卡交易金额，写 USD。数字去尾零（fmtPlain）。
import { interpolate } from './errors';
import { fmtPlain, isZero, toMicro } from './money';

export interface AuthCancelFeeFields {
  auth_cancel_fee_rate: string;
  auth_cancel_fee_fixed: string;
  auth_cancel_fee_min: string;
}

// fixed：固定费段模板（{fee}，如「每笔 {fee} USDT」）；cond：门槛条件段（{min}，如「（撤销金额 ≥ {min} USD 时收取）」）
export interface AuthCancelFeeTpl {
  fixed: string;
  cond: string;
}

function zeroOf(v: string): boolean {
  try {
    return isZero(toMicro(v));
  } catch {
    return true; // 非法值视为未配置：不向用户展示错误费用
  }
}

// 返回空串 = 比例与固定费皆为 0（调用方不渲染该项）。比例段只在非 0 时前置；门槛 0 = 每笔都收，不带条件段。
export function authCancelFeeText(p: AuthCancelFeeFields, tpl: AuthCancelFeeTpl): string {
  const hasRate = !zeroOf(p.auth_cancel_fee_rate);
  const hasFixed = !zeroOf(p.auth_cancel_fee_fixed);
  if (!hasRate && !hasFixed) return '';
  const rate = hasRate ? `${fmtPlain(p.auth_cancel_fee_rate)}%` : '';
  if (!hasFixed) return rate;
  const fixed = interpolate(tpl.fixed, { fee: fmtPlain(p.auth_cancel_fee_fixed) });
  const cond = zeroOf(p.auth_cancel_fee_min) ? '' : interpolate(tpl.cond, { min: fmtPlain(p.auth_cancel_fee_min) });
  return `${rate ? `${rate} + ` : ''}${fixed}${cond}`;
}
